import React, { ReactElement } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { Typography } from "@material-ui/core";
import { InvoiceParsingErrorListDialog } from "./InvoiceParsingErrorListDialog";
import { InvoiceParsingError } from "../../models/Invoice";

interface InvoiceFileSetParsingErrorSectionProps {
	//The list of errors to be displayed in the dialog.
	errorList: InvoiceParsingError[];
	//The total count of errors that occured in while parsing the csv.
	errorCount: number;
	//The callback method for setting the dialog contents.
	setDialogContents: (title: string, element: ReactElement | undefined) => void;
}

const useStyles = makeStyles((theme) => ({
	content: {
		fontSize: 11,
		fontWeight: 700,
		letterSpacing: ".15em",
		marginLeft: 10,
	},
	button: {
		marginBottom: 5,
		marginLeft: theme.spacing(2),
		float: "right",
		width: 120,
	},
}));

/**
 * This component is used for displaying the error section of an invoice history database record.
 * @param props
 */
export const InvoiceFileSetParsingErrorSection = (props: InvoiceFileSetParsingErrorSectionProps) => {
	const classes = useStyles();
	return (
		<div className={classes.content}>
			<Typography style={{ marginTop: 10, marginBottom: 10, marginRight: 5, fontWeight: "bold" }}>
				Parsing Errors
			</Typography>
			{props.errorCount > 0 ? (
				<div
					style={{
						display: "flex",
					}}
				>
					<div style={{ whiteSpace: "nowrap" }} data-testid={"invoice-parsing-error-count-display"}>
						<Typography>{`Parsing Error Count: ${props.errorCount}`}</Typography>
					</div>
					<div
						style={{
							height: 40,
							margin: "auto",
							marginRight: 80,
							whiteSpace: "nowrap",
							float: "right",
							justifySelf: "flex-end",
						}}
					>
						<Button
							size="small"
							variant="outlined"
							color={"primary"}
							onClick={() => {
								props.setDialogContents(
									"Parsing Errors",
									<InvoiceParsingErrorListDialog errorList={props.errorList}></InvoiceParsingErrorListDialog>,
								);
							}}
							className={classes.button}
							data-testid="view-parsing-errors-button"
						>
							{"View Errors"}
						</Button>
					</div>
				</div>
			) : (
				<Typography>No Parsing Errors Occurred</Typography>
			)}
		</div>
	);
};
